/** Lowercase 40-char hex (no 0x), aligned with backend swapdex.WrappedNativeRef. */
export const WRAPPED_NATIVE_BY_CHAIN: Record<string, string> = {
  ethereum: 'c02aaa39b223fe8d0a0e5c4f27ead9083c756cc2',
  sepolia: '7b79995e5f793a07bc00c21412e50ecae098e7f9',
  bsc: 'bb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c',
  base: '4200000000000000000000000000000000000006',
  avax: 'b31f66aa3c1e785363f0875a1b74e27b85fd66c7',
  polygon: '0d500b1d8e8ef31e21c99d1db9a6444d3adf1270',
  arb: '82af49447d8a07e3bd95bd0d56f35241523fbab1',
  op: '4200000000000000000000000000000000000006',
};

export function isWrappedNativeToken(chain: string, tokenRef: string): boolean {
  const w = WRAPPED_NATIVE_BY_CHAIN[chain];
  if (!w) {
    return false;
  }
  return tokenRef.toLowerCase() === w;
}

/** Default spender: in-app Exchange router (same on all supported EVM chains). */
export const DEFAULT_TOKEN_SPENDER = '0x0000000000dd54EDb11B6f58FBcE84Ccf2F95538';
